export default ({ formTitle, cognitoSrc }) => {
  return {
    formTitle,
    cognitoSrc,
  };
};
